/* global bootstrap */

import React, { useContext } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";
import axiosInstance from "../utils/Requests/axios";
import UserContext from "../utils/Contexts/UserContext";
import toast from "react-hot-toast";
import Constant from "../components/Constants";
import ThemeContext from "../utils/Contexts/ThemeContext";

function DeletePaymentModal({ card, setAddedCards }) {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();

  const handleDeleteWebsite = () => {
    const url = `/users/${userData?.uuid}/cards/${card?.uuid}`;
    try {
      axiosInstance.delete(url);
      setAddedCards((prevCards) =>
        prevCards.filter((item) => item.uuid !== card.uuid)
      );
      toast.success(t("Your card has been deleted"));
      const modalElement = document.getElementById("deletePaymentModal");
      const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
      bootstrapModal?.hide();
    } catch (error) {
      toast.error(t("There was an error deleting the Card"));
    }
  };

  return (
    <div
      className={`modal fade deletePaymentModal ${themeStatus?.[selectedTheme]}`}
      id="deletePaymentModal"
      tabIndex="-1"
      aria-labelledby="deletePaymentModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered custom-modal">
        <div
          className="modal-content "
          style={{ background: "var(--filter-bg)" }}
        >
          <div className="modal-header px-3">
            <h3 className="modal-title" id="deletePaymentModalLabel">
              {t("Are you sure you want to delete this card?")}
            </h3>
          </div>

          <div className="modal-body pt-2 pb-0 px-3">
            <div
              key={card?.id}
              className={`my-2 pt-3 pb-0 pb-sm-3 pb-lg-2 bg-access-detail-dark rounded ${
                card?.primary === true
                  ? "bg-soft-secondary"
                  : "bg-access-detail-dark"
              } rounded`}
            >
              <div className="px-3 py-0 ">
                <div className="d-flex justify-content-between pb-3">
                  {card?.Icon && <card.Icon />}

                  {card?.primary === true && (
                    <p
                      className="bg-soft-primary text-primary d-flex align-items-center justify-content-center"
                      style={{
                        margin: "unset",
                        borderRadius: "5px",
                        height: "29px",
                        width: "90px",
                      }}
                    >
                      {t("Primary")}
                    </p>
                  )}
                </div>

                <div className="d-flex justify-content-between flex-lg-row flex-column gap-2">
                  <div className="d-flex flex-lg-column flex-row justify-content-between align-items-center align-items-lg-start">
                    <h5
                      className={`${
                        card?.primary ? "text-dark" : "text-white"
                      } visa-label`}
                    >
                      {card?.label}
                    </h5>
                    <p
                      className={`${
                        card?.primary ? "text-dark" : "text-white"
                      } responsive-text`}
                      style={{ marginBottom: "unset" }}
                    >
                      {t("Expires")}{" "}
                      {`${card?.exp_month || ""}/${
                        card?.exp_year?.toString().slice(-2) || ""
                      }`}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal-footer gap-3 gap-sm-2 px-3 py-4"
            style={{ border: "unset" }}
          >
            <button
              type="button"
              className="btn btn-outline-primary d-flex justify-content-center align-items-center px-0 btn-payment-modal-learn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              {t("No, Keep Card")}
            </button>
            <button
              type="button"
              className="btn btn-danger d-flex justify-content-center align-items-center px-0 btn-payment-modal-del"
              onClick={handleDeleteWebsite}
            >
              {t("Yes, Delete")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeletePaymentModal;
